import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function PackagingMakeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    packagingQualifier: Yup.string().nullable(),
    quantity: Yup.string().required(requiredMessage).matches("^[0-9\-]*$", "Should be a valid digits Quantity").nullable(),
    uom: Yup.string().required(requiredMessage).nullable(),
  })
}

export default PackagingMakeValidationSchema
